import React from "react";
import Grid from "../../../Grid/Grid";
import "./home-what.scss";

const HomeWhat = () => {
  return (
    <section className="home-what">
      <Grid>
        <div className="home-what__container">
          <h2 className="home-what__heading">What is AskTheStar?</h2>
          <p className="home-what__content">
            AskTheStar is a new platform for audience connection. Authors,
            celebrities and influencers engage with their audiences directly in
            a Q&A format, while being compensated for their time. With
            AskTheStar, you can not only generate more income, you can also
            choose to support your favorite charities.
          </p>
        </div>
      </Grid>
    </section>
  );
};

export default HomeWhat;
